// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContributionsPage.module.css */

.ContributionsPage_container__GmCY5 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.ContributionsPage_title__M7Tv5 {
  color: rgb(151, 1, 14);
  font-family: "Ysabeau SC", sans-serif;
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.ContributionsPage_subtitle__2p6HX {
  color: rgb(151, 1, 14);
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.5rem;
  margin: 2rem 0;
  text-align: center;
}

.ContributionsPage_balance__aA8kn {
  font-size: 1.2rem;
  margin: 1rem 0;
  text-align: center;
}

.ContributionsPage_formSection__VFrrV {
  margin-bottom: 1.5rem;
}

.ContributionsPage_label__tPm8s {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.ContributionsPage_input__nguUs {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s ease-in-out;
}

.ContributionsPage_input__nguUs:focus {
  border-color: rgb(151, 1, 14);
  outline: none;
}

.ContributionsPage_select__n0cQF {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  margin-right: 1rem;
}

.ContributionsPage_regionSelectContainer__Z97mo {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.ContributionsPage_backButton__PC6m3 {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  margin-bottom: 2rem;
  background-color: white;
  color: rgb(151, 1, 14);
  border: 2px solid rgb(151, 1, 14);
  border-radius: 8px;
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ContributionsPage_backButton__PC6m3:hover {
  background-color: rgb(151, 1, 14);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ContributionsPage_submitButton__nTM9q, .ContributionsPage_addButton__fnoTp {
  background-color: rgb(151, 1, 14);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ContributionsPage_submitButton__nTM9q:hover, .ContributionsPage_addButton__fnoTp:hover {
  background-color: rgb(121, 1, 11);
}

.ContributionsPage_cancelButton__QPl6U {
  background-color: #666;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ContributionsPage_cancelButton__QPl6U:hover {
  background-color: #444;
}

.ContributionsPage_deleteButton__yy5XM {
  background-color: #ff4444;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ContributionsPage_deleteButton__yy5XM:hover {
  background-color: #cc0000;
}

.ContributionsPage_tableContainer__1FXcI {
  overflow-x: auto;
  margin-top: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ContributionsPage_table__uAfXh {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.ContributionsPage_table__uAfXh th,
.ContributionsPage_table__uAfXh td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.ContributionsPage_table__uAfXh th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.ContributionsPage_tableRow__wQHvM {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ContributionsPage_tableRow__wQHvM:hover {
  background-color: #f9f9f9;
}

.ContributionsPage_modal__e7YgI {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ContributionsPage_modalContent__8dRqi {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}

.ContributionsPage_modalActions__U\\+niT {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.ContributionsPage_error__pF8Px {
  color: #ff4444;
  margin: 1rem 0;
  padding: 1rem;
  background-color: #ffe5e5;
  border-radius: 4px;
  text-align: center;
}

.ContributionsPage_loading__EuIWN {
  text-align: center;
  padding: 2rem;
  color: rgb(151, 1, 14);
  font-size: 1.2rem;
}

.ContributionsPage_retryButton__uSWvG {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.6rem 1.2rem;
  background-color: rgb(151, 1, 14);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ContributionsPage_retryButton__uSWvG:hover {
  background-color: rgb(121, 1, 11);
}

@media (max-width: 768px) {
  .ContributionsPage_container__GmCY5 {
    padding: 1rem;
  }

  .ContributionsPage_title__M7Tv5 {
    font-size: 1.5rem;
  }

  .ContributionsPage_subtitle__2p6HX {
    font-size: 1.2rem;
  }

  .ContributionsPage_regionSelectContainer__Z97mo {
    flex-direction: column;
  }

  .ContributionsPage_select__n0cQF {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .ContributionsPage_backButton__PC6m3 {
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/ContributionsPage/ContributionsPage.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["/* ContributionsPage.module.css */\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.title {\n  color: rgb(151, 1, 14);\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.subtitle {\n  color: rgb(151, 1, 14);\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 1.5rem;\n  margin: 2rem 0;\n  text-align: center;\n}\n\n.balance {\n  font-size: 1.2rem;\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.formSection {\n  margin-bottom: 1.5rem;\n}\n\n.label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.input {\n  width: 100%;\n  padding: 0.8rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease-in-out;\n}\n\n.input:focus {\n  border-color: rgb(151, 1, 14);\n  outline: none;\n}\n\n.select {\n  width: 100%;\n  padding: 0.8rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 1rem;\n  margin-right: 1rem;\n}\n\n.regionSelectContainer {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.8rem 1.5rem;\n  margin-bottom: 2rem;\n  background-color: white;\n  color: rgb(151, 1, 14);\n  border: 2px solid rgb(151, 1, 14);\n  border-radius: 8px;\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.backButton:hover {\n  background-color: rgb(151, 1, 14);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.submitButton, .addButton {\n  background-color: rgb(151, 1, 14);\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.submitButton:hover, .addButton:hover {\n  background-color: rgb(121, 1, 11);\n}\n\n.cancelButton {\n  background-color: #666;\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.cancelButton:hover {\n  background-color: #444;\n}\n\n.deleteButton {\n  background-color: #ff4444;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.deleteButton:hover {\n  background-color: #cc0000;\n}\n\n.tableContainer {\n  overflow-x: auto;\n  margin-top: 2rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.table th,\n.table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n}\n\n.tableRow {\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.tableRow:hover {\n  background-color: #f9f9f9;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.error {\n  color: #ff4444;\n  margin: 1rem 0;\n  padding: 1rem;\n  background-color: #ffe5e5;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: rgb(151, 1, 14);\n  font-size: 1.2rem;\n}\n\n.retryButton {\n  display: inline-block;\n  margin-top: 1rem;\n  padding: 0.6rem 1.2rem;\n  background-color: rgb(151, 1, 14);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.retryButton:hover {\n  background-color: rgb(121, 1, 11);\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 1.2rem;\n  }\n\n  .regionSelectContainer {\n    flex-direction: column;\n  }\n\n  .select {\n    margin-right: 0;\n    margin-bottom: 1rem;\n  }\n\n  .backButton {\n    font-size: 1rem;\n    padding: 0.6rem 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContributionsPage_container__GmCY5`,
	"title": `ContributionsPage_title__M7Tv5`,
	"subtitle": `ContributionsPage_subtitle__2p6HX`,
	"balance": `ContributionsPage_balance__aA8kn`,
	"formSection": `ContributionsPage_formSection__VFrrV`,
	"label": `ContributionsPage_label__tPm8s`,
	"input": `ContributionsPage_input__nguUs`,
	"select": `ContributionsPage_select__n0cQF`,
	"regionSelectContainer": `ContributionsPage_regionSelectContainer__Z97mo`,
	"backButton": `ContributionsPage_backButton__PC6m3`,
	"submitButton": `ContributionsPage_submitButton__nTM9q`,
	"addButton": `ContributionsPage_addButton__fnoTp`,
	"cancelButton": `ContributionsPage_cancelButton__QPl6U`,
	"deleteButton": `ContributionsPage_deleteButton__yy5XM`,
	"tableContainer": `ContributionsPage_tableContainer__1FXcI`,
	"table": `ContributionsPage_table__uAfXh`,
	"tableRow": `ContributionsPage_tableRow__wQHvM`,
	"modal": `ContributionsPage_modal__e7YgI`,
	"modalContent": `ContributionsPage_modalContent__8dRqi`,
	"modalActions": `ContributionsPage_modalActions__U+niT`,
	"error": `ContributionsPage_error__pF8Px`,
	"loading": `ContributionsPage_loading__EuIWN`,
	"retryButton": `ContributionsPage_retryButton__uSWvG`
};
export default ___CSS_LOADER_EXPORT___;
